module.exports = __webpack_public_path__ + "static/media/2010.39360b42.svg";